//Creates new Tip Box and assigns ID and type
export const createTipBox = (data) => {
    //data = {id, type}
    return { type: "CREATE_TIP_BOX", payload: data}
}

//Change tip attached status
export const tipBoxOpen = (data) => {
    //data = {id, open}
    return { type: "TIP_BOX_OPEN", payload: data}
}
